export default "__VITE_ASSET__veD47vHX__"